import { connect } from 'react-redux'
import { chatbotSelectors, getStep, PortfolioWizardStepNames } from 'modules/ui/ChatBot'
import { ChatBot } from '../../components'
import { portfolioEvents } from 'modules/portfolios/state'

const mapStateToProps = (state, { push }: any) => ({
  actions: [],
  step: getStep(PortfolioWizardStepNames.tenants),
  displayStep: chatbotSelectors.getCurrentPortfolioStatus(state) === 'in progress',
  title: 'Tenants',
  displayTitleAction: true,
  titleActionText: 'Add tenant',
})

const mapDisptchToProps = (dispatch: any) => ({
  actionClickHandler: (action: any) => dispatch(action()),
  titleActionClickHandler: () => dispatch(portfolioEvents.togglePartyModal()),
})

export default connect(mapStateToProps, mapDisptchToProps)(ChatBot)
